import './scss/index.scss';
import '../game-event-card/index';
import ComponentsFactory from 'foundation/components-factory';
import upcomingEvents from './js/upcoming-events.component';

ComponentsFactory.getInstance().define('upcoming-events', upcomingEvents);
